import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import CustomIcon from "../../../../../../../public/icons-v1_1";
import OrderHistoryDocumentFileSelector from "@/features/my-order/features/order-history/components/document-section/OrderHistoryDocumentFileSelector";
import OrderHistoryButton from "@/features/my-order/features/order-history/components/OrderHistoryButton";
import useOrderHistoryDetail from "@/features/my-order/features/order-history/hooks/useOrderHistoryDetail";
import useDownloadUnoFile from "@/hooks/use-download-uno-file";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import OrderHistorySectionCard from "@/features/my-order/features/order-history/components/OrderHistorySectionCard";

function OrderHistoryDocumentSection() {
  const { data } = useOrderHistoryDetail();
  const { fire: fireDownloadUnoFile } = useDownloadUnoFile();
  const { tTitle } = useI18nHelper();

  return (
    <OrderHistorySectionCard
      titleKey={"order_history:documents"}
      iconSrc={"folder"}
      actions={
        <>
          {data?.compressed_attachment_file?.id && (
            <OrderHistoryButton
              leadingIconSrc={"download"}
              disabled={!data?.compressed_attachment_file?.id}
              onClick={() => {
                if (!data?.compressed_attachment_file?.id) return;
                fireDownloadUnoFile(
                  {
                    unoFileId: data.compressed_attachment_file.id,
                  },
                  {}
                );
              }}
            >
              {tTitle("order_history:download_all")}
            </OrderHistoryButton>
          )}
        </>
      }
    >
      <OrderHistoryDocumentFileSelector />
    </OrderHistorySectionCard>
  );
}

export default OrderHistoryDocumentSection;
